import { useState, useEffect } from "react";
import { Card } from "@/components/ui/card";
import { Button } from "@/components/ui/button";
import { X, ArrowRight, Zap, Target, TrendingUp } from "lucide-react";

const WelcomeModal = () => {
  const [isOpen, setIsOpen] = useState(false);
  const [step, setStep] = useState(0);

  useEffect(() => {
    const hasSeenWelcome = localStorage.getItem('ism-welcome-seen');
    if (!hasSeenWelcome) {
      setIsOpen(true);
    }
  }, []);

  const steps = [
    {
      icon: Zap,
      title: "Welcome to Intelligent Sales Machines",
      description: "Your autonomous AI sales agent that works 24/7 to help you hit your revenue goals.",
      color: "text-[#3dd9c5]"
    },
    {
      icon: Target,
      title: "Autonomous Agent",
      description: "Watch the Autonomous Stream as your AI agent continuously researches prospects, crafts outreach, and identifies opportunities.",
      color: "text-[#3dd9c5]"
    },
    {
      icon: TrendingUp,
      title: "Command Module",
      description: "Use Hunt, Farm, and Advisor modes to direct your agent. Natural language commands like 'find 10 prospects in fintech' work seamlessly.",
      color: "text-[#3dd9c5]"
    }
  ];

  const handleClose = () => {
    localStorage.setItem('ism-welcome-seen', 'true');
    setIsOpen(false);
  };

  const handleNext = () => {
    if (step < steps.length - 1) {
      setStep(step + 1);
    } else {
      handleClose();
    }
  };

  if (!isOpen) return null;

  const currentStep = steps[step];
  const Icon = currentStep.icon;

  return (
    <div className="fixed inset-0 bg-black/80 backdrop-blur-sm z-50 flex items-center justify-center p-6 animate-fade-in">
      <Card className="bg-[#0f1419] border-gray-800 p-8 max-w-2xl w-full relative">
        <button
          onClick={handleClose}
          className="absolute top-4 right-4 text-gray-400 hover:text-white transition-colors"
          data-testid="close-welcome"
        >
          <X className="h-5 w-5" />
        </button>

        <div className="text-center mb-8">
          <div className="inline-flex items-center justify-center w-20 h-20 bg-[#3dd9c5]/10 rounded-full mb-6">
            <Icon className={`h-10 w-10 ${currentStep.color}`} />
          </div>
          <h2 className="text-3xl font-bold text-white mb-4">{currentStep.title}</h2>
          <p className="text-lg text-gray-400 leading-relaxed">{currentStep.description}</p>
        </div>

        <div className="flex items-center justify-between">
          <div className="flex gap-2">
            {steps.map((_, idx) => (
              <div
                key={idx}
                className={`h-2 rounded-full transition-all duration-300 ${
                  idx === step ? 'w-8 bg-[#3dd9c5]' : 'w-2 bg-gray-700'
                }`}
              />
            ))}
          </div>
          <Button
            onClick={handleNext}
            className="bg-[#3dd9c5] hover:bg-[#35c4b5] text-white"
            data-testid="next-welcome"
          >
            {step < steps.length - 1 ? (
              <>
                Next <ArrowRight className="h-4 w-4 ml-2" />
              </>
            ) : (
              "Get Started"
            )}
          </Button>
        </div>
      </Card>
    </div>
  );
};

export default WelcomeModal;
